import React from 'react';
import { Button } from 'react-bootstrap';
import { GOOGLE_LOGIN_URL } from '../api/client';

/**
 * Shown on 403: the login is valid but has no trainer account. Typical cause: a remember-me session, which carries no
 * Google identity. The button starts a fresh Google login. Nothing redirects automatically, so there is no loop.
 */
const ForbiddenScreen: React.FC = () => (
  <div className="login-hero">
    <div className="surface login-card">
      <div className="navbar-brand-mark mx-auto mb-3" aria-hidden="true">T</div>
      <h1 className="h4 mb-2">Log in again</h1>
      <p className="muted mb-4" role="alert">
        This session is signed in but has no trainer access. This usually happens with an automatic (remember-me) login,
        or after your trainer data was deleted. Log in with Google again to continue.
      </p>
      <Button
        variant="primary"
        size="lg"
        className="w-100"
        onClick={() => {
          window.location.href = GOOGLE_LOGIN_URL;
        }}
      >
        Log in again
      </Button>
    </div>
  </div>
);

export default ForbiddenScreen;
